import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCommandDropdown } from "../context";
import { EmptyProps } from "../types";

export function Empty({ children, className }: EmptyProps) {
    const { t } = useTranslation("", { keyPrefix: "general.components.command" });
    const { itemCount, isLoading } = useCommandDropdown();

    // Only show when there are no items and not loading
    if (itemCount > 0 || isLoading) {
        return null;
    }

    const content = children ?? t("noResults");

    return (
        <Box className={className} sx={{ padding: 3, textAlign: "center" }}>
            {typeof content === "string" ? (
                <Typography variant="body2" sx={{ opacity: 0.7 }}>
                    {content}
                </Typography>
            ) : (
                content
            )}
        </Box>
    );
}

export default Empty;
